import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeLineIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="shapeLine" ref={ref} {...props}>
      <path d="M4,20.75a.74.74,0,0,1-.53-.22.75.75,0,0,1,0-1.06l16-16a.75.75,0,1,1,1.06,1.06l-16,16A.74.74,0,0,1,4,20.75Z" />
    </Icon>
  ),
) as IconWithRender;

ShapeLineIcon.displayName = 'ShapeLineIcon';
ShapeLineIcon.renderIcon = (props) => <ShapeLineIcon {...props} />;
export default ShapeLineIcon;
